<template>
	<v-card v-if="!totalsHidden" :elevation="1" class="background-2 round-card">
        <v-card-title class="pa-3">
			<p class="pl-2 pl-xl-3">Totali</p>
	        <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-container class="py-3 px-3">
            <totals-cards
				:totals-fields="computedTotalsFields"
				:data="computedTotalsData"
				:hidden="totalsHidden"
			></totals-cards>
        </v-container>
    </v-card>
</template>
<script>
	import TotalsCards from '@/components/common/TotalsCards'

    export default {
        name: "trouble-totals",

		components: {
			TotalsCards
		},

        props: {
            total: Number,
            subtotal: Number,
            tax: Number,
			totalsFieldsConfig: {
				type: Array,
				default: null
			},
			totalsHidden: {
				type: Boolean,
				default: false
			}
        },

		computed: {
			defaultTotalsFields() {
				return [
					{
						text: 'Imponibile',
						key: 'subtotal',
						icon: 'mdi-cash-multiple',
						type: 'currency',
						color: 'blue',
						large: true
					},
					{
						text: 'IVA',
						key: 'tax',
						icon: 'mdi-percent',
						type: 'currency',
						color: 'orange'
					},
					{
						text: 'Totale',
						key: 'total',
						icon: 'mdi-cash',
						type: 'currency',
						color: 'green',
						large: true
					}
				]
			},
			computedTotalsFields() {
				return this.totalsFieldsConfig || this.defaultTotalsFields
			},
			computedTotalsData() {
				return {
					subtotal: this.subtotal,
					tax: this.tax,
					total: this.total
				}
			}
		}
    }
</script>